import React from 'react'
import PropTypes from 'prop-types'
import {
    Row,
    Container,
    Button
} from 'reactstrap'
import { connect } from 'react-redux'
import { select } from '@rematch/select'

import PageTitle from 'components/PageTitle'
import SubNavigation from 'components/SubNavigation'
import Roles from 'features/auth/Roles'
import View from 'components/View'
import userManager from 'services/UserManager'

import CleaningHistoryFilter from './components/CleaningHistoryFilter'
import CleaningHistory from './components/CleaningHistory'

import './DashboardIndex.scss'
class DashboardIndex extends React.Component {

    static propTypes = {
        organisationId: PropTypes.number,
        roles: PropTypes.array
    }

    constructor(props) {
        super(props)
        this.state = {
            startdate: '',
            enddate: ''
        }
    }

    handleFilterChanged = filter => {
        this.setState({
            [filter.target.name]: filter.target.value
        })
    }

    handleLogout = () => {
        // Clear session storage
        sessionStorage.removeItem('ARO_ADMIN_SID')
        // Redirect to the identity provider logout page
        userManager.signoutRedirect()
    }

    render() {
        const {
            roles
        } = this.props

        const {
            startdate,
            enddate
        } = this.state

        const filterLabel = startdate && enddate
            ? `${ startdate } t/m ${ enddate }`
            : 'Selecteer periode'

        if (roles && roles.indexOf(Roles.SuperAdmin) < 0) {
            return (
                <React.Fragment>
                    <SubNavigation />
                    <View>
                        <h3>
                            De schonen functionaliteit is alleen beschikbaar voor systeem admins
                        </h3>
                        <Button color="primary" onClick= { this.handleLogout } className="mt-3">
                            Uitloggen
                        </Button>
                    </View>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <SubNavigation />
                <View>
                    <Container>
                        <Row>
                            <PageTitle>Schonen historie</PageTitle>
                            <Button color="primary" onClick= { this.handleLogout } >
                                Uitloggen
                            </Button>
                        </Row>

                        <CleaningHistoryFilter
                            start={ startdate }
                            end={ enddate }
                            label={ filterLabel }
                            onSelectionChanged={ this.handleFilterChanged }
                        />
                        <CleaningHistory
                            startdate={ startdate }
                            enddate={ enddate }
                        />
                    </Container>
                </View>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        roles: select.profile.roles(state)
    }
}

export default connect(mapStateToProps, null)(DashboardIndex)
